module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05_dedication"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("To Becky,")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_c('em', [_vm._v("in celebration of our 40 years!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/com.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_c('em', [_vm._v("And to Helen Keller,")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_c('em', [_vm._v("whom I grew to enjoy")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_c('em', [_vm._v("far more than I ever imagined I would.")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9000f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_dedication.vue
// module id = 69
// module chunks = 0